import { render } from "./LookForBSSHSamples.vue?vue&type=template&id=cf1adb9c&scoped=true"
import script from "./LookForBSSHSamples.vue?vue&type=script&lang=js"
export * from "./LookForBSSHSamples.vue?vue&type=script&lang=js"

import "./LookForBSSHSamples.vue?vue&type=style&index=0&id=cf1adb9c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf1adb9c"]])

export default __exports__